@if (gotDgProperties) {
  <app-grid-view #gridView
    [apiPath]="dgApiPath"
    [autoLoad]="false" 
    [dgActionColumn]="dgActionColumn"
    [dgColumns]="dgColumns"
    [dgPopup]="dgPopup"
    [dgProperties]="dgProperties"
    [dgTabs]="dgTabs"
    (addButtonClick)="gridAddButtonClick($event)"
    (contentReady)="onContentReady($event)"
    (deleteButtonClick)="gridDeleteButtonClick($event)"
    (editButtonClick)="gridEditButtonClick($event)"
    (moreButtonClick)="gridMoreButtonClick($event)"
    (rowClick)="gridRowClick($event)"
    (rowExpanding)="gridRowExpanding($event)"
    (tabChanged)="onTabChange($event)"
  >
    <app-country-group-countries #groupCountries></app-country-group-countries>
  </app-grid-view>
}
